// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__0x0rp"};